const styles = (theme) => ({
  drawer: {
    width: 256,
    backgroundColor: theme.palette.layout.main,
    position: 'fixed',
    top: 'calc(var(--dpoday-banner-height, 0px) + 56px)',
    height: 'calc(100% - (var(--dpoday-banner-height, 0px) + 56px))',
    transition: 'top 0.3s ease, height 0.3s ease',
    [theme.breakpoints.up('sm')]: {
      top: 'calc(var(--dpoday-banner-height, 0px) + 64px)',
      height: 'calc(100% - (var(--dpoday-banner-height, 0px) + 64px))',
    },
  },
  standardBackground: {
    backgroundImage: `linear-gradient(to bottom, ${theme.palette.primary.main} 80%, ${theme.palette.primary.hover} 100%)`,
  },
  customBackground: {
    backgroundColor: theme.palette.layout.main,
  },
  drawerFullScreen: {
    width: '100vw',
    position: 'fixed',
    top: 'calc(var(--dpoday-banner-height, 0px) + 56px)',
    height: 'calc(100% - (var(--dpoday-banner-height, 0px) + 56px))',
    transition: 'top 0.3s ease, height 0.3s ease',
    [theme.breakpoints.up('sm')]: {
      top: 'calc(var(--dpoday-banner-height, 0px) + 64px)',
      height: 'calc(100% - (var(--dpoday-banner-height, 0px) + 64px))',
    },
  },
})

export default styles
